import React, { useState } from "react";
import { TextareaAutosize } from "@mui/material";
import { SendIcon } from "@100mslive/react-icons";
import { IconButton } from "@100mslive/roomkit-react";
import EmojiPicker from "../../Common/EmojiPicker";

const EventReplayChatBottom = props => {
  const { sending, queryMsg, setQueryMsg, sendMessage } = props;
  const [enableAutoFocus, setEnableAutoFocus] = useState(false);
  return (
    <div className="attendee-area-col-replay-layout-chat-footer">
      {!sending ? (
        <>
          <TextareaAutosize
            autoFocus={enableAutoFocus}
            tabIndex={-1}
            maxRows={2}
            className="attendee-area-col-replay-layout-chat-footer-input"
            placeholder="Your message..."
            value={queryMsg}
            readOnly={sending}
            disabled={sending}
            onChange={e => setQueryMsg(e.target.value)}
            onKeyDown={e => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                sendMessage();
                setEnableAutoFocus(true);
              }
            }}
          />

          <div className="attendee-area-col-replay-layout-chat-footer-action">
            <EmojiPicker
              onSelect={emoji => {
                setQueryMsg(t => (t += ` ${emoji.native} `));
              }}
              classes="attendee-area-col-replay-layout-chat-footer-action-btn"
            />
            <IconButton
              onClick={() => {
                sendMessage();
                setEnableAutoFocus(true);
              }}
              className="attendee-area-col-replay-layout-chat-footer-action-btn"
            >
              <SendIcon />
            </IconButton>
          </div>
        </>
      ) : (
        <div className="attendee-area-col-replay-layout-chat-footer-loading">
          Sending ...
        </div>
      )}
    </div>
  );
};

export default EventReplayChatBottom;
